import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import { ghostButtonClass, Status } from "../components/ui";
import { landingPathFor } from "../lib/landing";
import { getRole } from "../lib/auth";

// Placeholder keeps every navigable route addressable while its screen is
// still being built, so no menu entry or action card dead-ends.
export function Placeholder({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation();
  return (
    <>
      {getRole() !== "teacher" && (
        <NavLink to={landingPathFor(getRole() ?? undefined)} className={`${ghostButtonClass} mb-4`}>
          <ChevronLeft size={16} />
          {t("backToHome")}
        </NavLink>
      )}
      <Status variant="empty" title={t(titleKey)} message={t("screenComingSoon")} />
    </>
  );
}
